import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import CMSTable from '../../components/general/CMSTable'
import { columns } from '../../utilities/columns/sliderColumns'
import CrudSlider from './CrudSliderGroup'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSliderGroupGetAll } from '../../redux/slices/sliderGroupGetAllSlice'
import { fetchSliderGroupDelete } from '../../redux/slices/sliderGroupDeleteSlice'
import { useNavigate } from 'react-router-dom'

const SliderGroupPage = () => {
    const { t } = useTranslation()
    const [selectedItem, setSelectedItem] = useState(0)
    const [changed, setChanged] = useState(false)
    const [loading, setLoading] = useState(false);
    const lang = useSelector((state) => state.lang.lang)
    const sliderGroups = useSelector((state) => state.sliderGroupGetAll.data)
    const [showMenu, setShowMenu] = useState(false)
    const navigation = useNavigate()
    const dispatch = useDispatch()

    const getData = async () => {
        setLoading(true);
        await dispatch(fetchSliderGroupGetAll())
        setChanged(false)
        setLoading(false);
    }
    
    useEffect(() => {
        getData()
    }, [dispatch, changed])

    const deleteData = async (id) => {
        await dispatch(fetchSliderGroupDelete({ id: id }))
        await dispatch(fetchSliderGroupGetAll())
    }

    return (
        <CMS>
            <PageBanner
                modal={showMenu}
                setModal={setShowMenu}
                title={t("slider_groups")}
                description={t("slider_group_description")}
                buttonText={t("slider_group_add")}
            />
            <CMSTable
                columns={columns({
                    t: t,
                    setSelectedItem: setSelectedItem,
                    modal: showMenu,
                    deleteData: deleteData,
                    navigation: navigation,
                    setModal: setShowMenu,
                    lang: lang
                })}
                data={sliderGroups}
                loading={loading}
            />
            <CrudSlider
                showMenu={showMenu}
                setShowMenu={setShowMenu}
                selectedItem={selectedItem}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                t={t}
            />
        </CMS>
    )
}

export default SliderGroupPage
